/* Bionobo reusable Page-owned guide catalog. No registry, events, storage or navigation. */
(function (global, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.BionoboGuideCatalog = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var instances = new WeakMap();
  var ID = /^[1-9][0-9]{0,19}$/;
  var PAGE = /^[1-9][0-9]{0,14}$/;
  var ROUTES = Object.freeze({
    'https://bionobo.ae': Object.freeze({ en: '/pages/guide-library' }),
    'https://bionobo-uae-y6xahe8t.myshopify.com': Object.freeze({ en: '/pages/guide-library' })
  });
  var HUB_ROUTES = Object.freeze({
    'https://bionobo.ae': Object.freeze({ en: '/pages/guides' }),
    'https://bionobo-uae-y6xahe8t.myshopify.com': Object.freeze({ en: '/pages/guides' })
  });
  var COPY = {
    en: {
      loading: 'Loading the complete guide library. More guides may be on later pages.',
      partial: 'Some library pages could not be loaded. The results shown are incomplete; use the page links below or retry.',
      invalid: 'The library could not be enhanced. Use the page and download links below.',
      stopped: 'Library loading was paused. The results may be incomplete; use the page links below.',
      empty: 'No enabled guides are available in this library.',
      complete: function (n) { return n + (n === 1 ? ' guide available.' : ' guides available.'); },
      badRequest: 'The requested guide or language is invalid. Browse the library below.',
      unavailable: 'The requested guide is unavailable. Browse the library below.',
      language: function (lang) { return 'This guide is unavailable in ' + (lang === 'ar' ? 'Arabic' : 'English') + '. Any other available language is labeled below.'; },
      selected: function (lang) { return 'Your guide is selected. Use the ' + (lang === 'ar' ? 'Arabic' : 'English') + ' download link.'; }
    }

  };
  COPY.ar = COPY.en; // Arabic downloads use the English storefront interface.
  function attr(node, name) { return node.getAttribute(name); }
  function compareDecimal(a, b) { return a.length - b.length || (a < b ? -1 : a > b ? 1 : 0); }
  function increment(value) {
    var digits = value.split('');
    for (var i = digits.length - 1; i >= 0; i--) {
      if (digits[i] !== '9') { digits[i] = String(Number(digits[i]) + 1); return digits.join(''); }
      digits[i] = '0';
    }
    return '1' + digits.join('');
  }
  function requestURL(origin, path, sectionId, page) {
    var url = new URL(path, origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', page);
    return url;
  }
  function continuation(href, context, currentPage) {
    var url = new URL(href, context.origin + context.path);
    if (url.origin !== context.origin || url.pathname !== context.path || url.username || url.password || url.hash) throw Error('Invalid continuation route');
    for (var key of url.searchParams.keys()) if (key !== 'page' && key !== 'section_id') throw Error('Unexpected continuation parameter');
    var pages = url.searchParams.getAll('page');
    var sections = url.searchParams.getAll('section_id');
    if (pages.length !== 1 || !PAGE.test(pages[0]) || pages[0] !== increment(currentPage)) throw Error('Invalid continuation page');
    if (sections.length > 1 || (sections.length && sections[0] !== context.sectionId)) throw Error('Invalid continuation section');
    return requestURL(context.origin, context.path, context.sectionId, pages[0]);
  }
  function trustedPDF(href, origin) {
    try {
      var url = new URL(href, origin);
      if (url.protocol !== 'https:' || url.username || url.password || url.hash || url.port) return false;
      var path = decodeURIComponent(url.pathname);
      if (/[\\\x00-\x1f]/.test(path)) return false;
      if (url.origin === 'https://cdn.shopify.com') return /^\/s\/files\/(?:[0-9]+\/)+files\/[^/]+\.pdf$/i.test(path);
      return !!ROUTES[url.origin] && /^\/cdn\/shop\/files\/[^/]+\.pdf$/i.test(path);
    } catch (_) { return false; }
  }
  function mount(root, options) {
    if (instances.has(root)) return instances.get(root);
    options = options || {};
    var location = new URL(options.location || globalThis.location.href);
    var lang = attr(root, 'data-language');
    var mode = attr(root, 'data-bn-guide-mode') || 'library';
    var copy = COPY[lang] || COPY.en;
    var status = root.querySelector('[data-bn-guide-record-status]');
    var cards = root.querySelector('[data-bn-guide-cards]');
    var retryButton = root.querySelector('[data-bn-guide-retry]');
    var sectionId = options.sectionId;
    var page = attr(root, 'data-page');
    var routes = (mode === 'hub' ? HUB_ROUTES : ROUTES)[location.origin];
    var context = { origin: location.origin, path: routes && routes[lang], sectionId: sectionId };
    var index = new Map();
    var libraryPanels = new Map();
    var completed = false;
    var stopped = false;
    var busy = false;
    var failure = null;
    var pending = null;
    var abort = typeof AbortController === 'function' ? new AbortController() : null;
    var fetchPage = options.fetch || globalThis.fetch.bind(globalThis);
    var parse = options.parse || function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
    var selection = null;
    var selectedIds = location.searchParams.getAll('guide');
    var languages = location.searchParams.getAll('lang');
    var requestedLang = languages.length ? languages[0] : lang;
    var invalidSelection = selectedIds.length > 1 || (selectedIds.length === 1 && !ID.test(selectedIds[0])) || languages.length > 1 || (languages.length === 1 && !COPY[requestedLang]);
    var selectedId = !invalidSelection && selectedIds.length ? selectedIds[0] : null;
    var selectionDone = attr(root, 'data-bn-guide-selection-done') === 'true';
    function announce(state, text) {
      root.setAttribute('data-bn-guide-state', state);
      if (cards) cards.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      if (retryButton) retryButton.hidden = state !== 'partial-error' || !pending;
      if (status) { status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.textContent = text; }
    }
    function importCards(batch) {
      for (var node of batch.querySelectorAll('[data-bn-guide-id]')) {
        var id = attr(node, 'data-bn-guide-id');
        if (!ID.test(id || '') || attr(node, 'data-bn-guide-enabled') !== 'true') continue;
        if (index.has(id)) { if (node.parentNode === cards && index.get(id) !== node) node.remove(); continue; }
        index.set(id, node);
        if (node.parentNode !== cards) cards.appendChild(node);
      }
    }
    function nextFrom(batch, currentPage) {
      var links = batch.querySelectorAll('a[data-bn-guide-next]');
      if (links.length > 1) throw Error('Ambiguous continuation');
      return links.length ? continuation(attr(links[0], 'href'), context, currentPage) : null;
    }
    function sortCards() {
      function order(node) { var value = attr(node, 'data-bn-guide-order') || '0'; return /^(0|[1-9][0-9]{0,19})$/.test(value) ? value : '0'; }
      var sorted = Array.from(index.entries()).sort(function (a, b) { return compareDecimal(order(a[1]), order(b[1])) || compareDecimal(a[0], b[0]); });
      if (mode !== 'library' || !sorted.some(function (entry) { return entry[1].querySelector('[data-bn-catalog-pdf-panel]'); })) {
        sorted.forEach(function (entry) { cards.appendChild(entry[1]); });
        return;
      }
      // Keep logical Page membership while restoring the original flat PDF-card grid.
      var flat = [];
      sorted.forEach(function (entry) {
        var panels = Array.from(entry[1].querySelectorAll('[data-bn-catalog-pdf-panel]'));
        libraryPanels.set(entry[0], panels);
        panels.forEach(function (panel) { flat.push({ node: panel, id: entry[0], guideOrder: order(entry[1]), lang: attr(panel, 'data-language') }); });
      });
      Array.from(root.querySelectorAll('[data-bn-catalog-legacy-language]')).forEach(function (node) {
        flat.push({ node: node, id: '', guideOrder: '0', lang: attr(node, 'data-bn-catalog-legacy-language') });
      });
      function sourceOrder(item) {
        var value = attr(item.node, 'data-bn-catalog-source-order');
        return /^(0|[1-9][0-9]{0,19})$/.test(value || '') ? value : null;
      }
      flat.sort(function (a, b) {
        var first = sourceOrder(a), second = sourceOrder(b);
        if (first !== null && second !== null) return compareDecimal(first, second);
        if (first !== null || second !== null) return first !== null ? -1 : 1;
        return compareDecimal(a.guideOrder, b.guideOrder) || compareDecimal(a.id, b.id);
      }).forEach(function (item) { cards.appendChild(item.node); });
      sorted.forEach(function (entry) { if (libraryPanels.get(entry[0]).length) entry[1].remove(); });
    }
    function finishSelection() {
      if (mode === 'hub' || selectionDone) return '';
      if (invalidSelection) { selection = 'invalid'; return copy.badRequest; }
      if (!selectedId) return '';
      var card = index.get(selectedId);
      var panels = libraryPanels.get(selectedId);
      if (panels && panels.length) card = panels.find(function (panel) { return attr(panel, 'data-language') === requestedLang; }) || panels[0];
      if (!card) { selection = 'unavailable'; return copy.unavailable; }
      var download = Array.from(card.querySelectorAll('[data-bn-guide-download]')).find(function (link) {
        return attr(link, 'data-bn-guide-download') === requestedLang && attr(link, 'aria-disabled') !== 'true' && trustedPDF(attr(link, 'href'), location.origin);
      });
      selection = download ? 'selected' : 'language-unavailable';
      card.hidden = false;
      card.id = 'selected-guide';
      card.classList.add('is-selected');
      card.setAttribute('data-bn-guide-selection', selection);
      card.setAttribute('tabindex', '-1');
      for (var details of card.querySelectorAll('[data-bn-guide-details]')) {
        details.hidden = false;
        if (details.tagName === 'DETAILS') details.open = true;
      }
      if (card.tagName === 'DETAILS') card.open = true;
      if (download) { download.hidden = false; download.setAttribute('data-bn-guide-requested-download', 'true'); }
      selectionDone = true;
      root.setAttribute('data-bn-guide-selection-done', 'true');
      card.focus({ preventScroll: true });
      card.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      return download ? copy.selected(requestedLang) : copy.language(requestedLang);
    }
    function finish() {
      completed = true;
      sortCards();
      var selectedText = finishSelection();
      announce('complete', selectedText || (index.size ? copy.complete(index.size) : copy.empty));
    }
    async function run() {
      if (busy || stopped || completed) return;
      busy = true;
      failure = null;
      announce('loading', copy.loading);
      try {
        while (pending && !stopped) {
          var response = await fetchPage(pending.href, { credentials: 'same-origin', redirect: 'error', signal: abort ? abort.signal : undefined, headers: { Accept: 'text/html' } });
          if (stopped) return;
          if (!response.ok || response.redirected) throw Error('Continuation request failed');
          // A test response may omit URL; browser responses must retain the exact route and query.
          if (response.url && response.url !== pending.href) throw Error('Unexpected continuation response URL');
          var html = await response.text();
          if (stopped) return;
          var document = parse(html);
          var batches = document.querySelectorAll('[data-bn-guide-catalog]');
          var matches = Array.from(batches).filter(function (batch) { return attr(batch, 'data-section-id') === sectionId; });
          if (matches.length !== 1) throw Error('Missing or ambiguous catalog section');
          var batch = matches[0];
          var requestedPage = pending.searchParams.get('page');
          if ((attr(batch, 'data-bn-guide-mode') || 'library') !== mode || attr(batch, 'data-language') !== lang || attr(batch, 'data-page') !== requestedPage || !batch.querySelector('[data-bn-guide-cards]')) throw Error('Unexpected catalog batch');
          // Validate the continuation before accepting a response; malformed batches never claim exhaustion.
          var next = nextFrom(batch, requestedPage);
          importCards(batch.querySelector('[data-bn-guide-cards]'));
          pending = next;
        }
        if (!stopped) finish();
      } catch (error) {
        if (!stopped) { failure = error.message; announce('partial-error', copy.partial); }
      } finally { busy = false; }
    }
    var controller = {
      ready: null,
      retry: function () { if (busy || completed || stopped || !pending) return controller.ready; controller.ready = run(); return controller.ready; },
      destroy: function () { if (stopped) return; stopped = true; if (abort) abort.abort(); if (retryButton) retryButton.removeEventListener('click', retryClicked); if (!completed) announce('paused', copy.stopped); },
      snapshot: function () { return { state: attr(root, 'data-bn-guide-state'), count: index.size, ids: Array.from(index.keys()), complete: completed, selection: selection, error: failure }; }
    };
    function retryClicked() { controller.retry(); }
    instances.set(root, controller);
    if (retryButton) { retryButton.hidden = true; retryButton.addEventListener('click', retryClicked); }
    if ((mode !== 'hub' && mode !== 'library') || !status || !cards || !COPY[lang] || !context.path || location.pathname !== context.path || typeof sectionId !== 'string' || !/^[A-Za-z0-9_-]{1,200}$/.test(sectionId) || attr(root, 'data-section-id') !== sectionId || !PAGE.test(page || '')) {
      announce('invalid-config', copy.invalid);
      controller.ready = Promise.resolve();
      return controller;
    }
    importCards(cards);
    try { pending = page === '1' ? nextFrom(root, page) : requestURL(context.origin, context.path, sectionId, '1'); }
    catch (error) { failure = error.message; announce('partial-error', copy.partial); controller.ready = Promise.resolve(); return controller; }
    controller.ready = run();
    return controller;
  }
  return Object.freeze({ mount: mount, validGuideId: function (id) { return typeof id === 'string' && ID.test(id); }, trustedPDF: trustedPDF });
});
